// extracted by mini-css-extract-plugin
export var content = "StaffDirectory-module--content--36e2f";
export var emailButton = "StaffDirectory-module--emailButton--34386";
export var modalCloseButton = "StaffDirectory-module--modalCloseButton--3a320";
export var staffGrid = "StaffDirectory-module--staffGrid--f4c6a";
export var staffdirectory = "StaffDirectory-module--staffdirectory--df539";